<template>
  <div>
    <div v-if="groups.length" class="flex items-center align-middle">
      <vx-tooltip :text="group.name" v-for="(group, gIndex) in groups" style="margin-top: 2px" :key="gIndex">
        <vs-avatar
          :color="group.color"
          :text="group.name.charAt(0).toUpperCase()"
          class="flex-shrink-0 mr-2"
          size="30px"
          @click="$router.push(`/a/groups/${group.id}`)"
        />
      </vx-tooltip>
    </div>
    <div v-else class="flex items-center align-middle">None</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      groups: []
    }
  },
  methods: {
    fetchGroupDetails (id) {
      this.$httpCached
        .get(`groups/${id}?cc=course_subscription_table_user_group`, {
          ttl: 15
        })
        .then((response) => {
          if (response.status === 200) {
            this.groups.push(response.data.data)
          }
        })
    }
  },
  created () {
    this.$httpCached
      .get(`users/${this.params.value}?cc=course_subscription_table_user_group`, {
        ttl: 15
      })
      .then((response) => {
        if (response.data.data.groups) {
          response.data.data.groups.forEach((group) => {
            this.fetchGroupDetails(group)
          })
        }
      })
  }
}
</script>
